import { render, staticRenderFns } from "./ChangeCollaboratorRole.vue?vue&type=template&id=6daa065d&scoped=true"
import script from "./ChangeCollaboratorRole.vue?vue&type=script&lang=js"
export * from "./ChangeCollaboratorRole.vue?vue&type=script&lang=js"
import style0 from "./ChangeCollaboratorRole.vue?vue&type=style&index=0&id=6daa065d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daa065d",
  null
  
)

export default component.exports